module.exports = __webpack_public_path__ + "static/media/apple-logo-black.00587615.svg";